import React, { useContext } from 'react'
import { AssetsContext } from '../context'
import { TabHeader } from '@components/TabHeader'

export const Header = () => {
  const { state } = useContext(AssetsContext)
  const { title, filter, screen } = state
  return (
    <TabHeader title={title}>
      <TabHeader.Filter filter={filter} view={screen} />
    </TabHeader>
  )
}
